import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '../languageSwitcher/LanguageSwitcher'
import './Header.css'

const BLUM_URL = 'https://t.me/blum/app?startapp=memepadjetton_LIGHTER_lfviO-ref_UsG1k7XbXa'
const STONFI_URL = 'https://app.ston.fi/swap?chartVisible=true&chartInterval=1w&ft=USD₮&tt=EQDheHEbyYsL5brD3uRxNgpxtH5KoUqdP6LC98iMhBNHyh0V&fa=%225%22&referral_address=UQB1ApXMxxg4Ddzx3XXxa4keJ-IgBDJq9sLWHdfcoVHCtfK5'
const OKX_URL = 'https://web3.okx.com/token/ton/EQDheHEbyYsL5brD3uRxNgpxtH5KoUqdP6LC98iMhBNHyh0V?shortCode=iBbiOsX&from_module=market_token&shareFrom=token_info&ref=LIGHTER999COIN'

// eslint-disable-next-line react/prop-types
export const Header = ({ scrollProgress = 0 }) => {
    const { t } = useTranslation()
    const story = t('story', { returnObjects: true })
    const [buyDropdownOpen, setBuyDropdownOpen] = useState(false)
    const dropdownRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setBuyDropdownOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <header className='site-header'>
            {/* Scroll progress bar */}
            <div className='scroll-progress-bar'>
                <div
                    className='scroll-progress-fill'
                    style={{ width: `${scrollProgress * 100}%` }} />
            </div>

            <div className='header-inner'>
                {/* Logo / brand */}
                <div className='header-logo'>
                    <img
                        src='/fire-icon.gif'
                        alt=''
                        className='header-flame-icon' />
                    <span className='header-brand'>$LIGHTER</span>
                </div>

                {/* Right side actions */}
                <div className='header-actions'>
                    <LanguageSwitcher compact />
                    <div
                        className='header-buy-wrapper'
                        ref={dropdownRef}>
                        <button
                            onClick={() => setBuyDropdownOpen(!buyDropdownOpen)}
                            className='header-buy-btn'
                            aria-label={story.buyAriaLabel}>
                            {story.ctaBuy || story.cta?.primary}
                        </button>
                        {buyDropdownOpen && (
                            <div className='header-buy-dropdown'>
                                <a
                                    href={BLUM_URL}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='header-buy-dropdown-item'>
                                    Blum Memepad
                                </a>
                                <a
                                    href={STONFI_URL}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='header-buy-dropdown-item'>
                                    {story.ctaBuyStonFi}
                                </a>
                                <a
                                    href={OKX_URL}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='header-buy-dropdown-item'>
                                    {story.ctaBuyOkx}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}
